import { inject, Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { LoanCalculatorModel } from '../../model/loan-calculator.model';
import { BizflexActions, ResetStateProps } from './bizflex.actions';
import * as BizflexSelectors from './bizflex.selectors';
import { CompanyModel } from '../../model/company.model';
import { DirectorModel } from '../../model/director.model';
import { LeadModel } from '../../model/lead.model';

@Injectable()
export class BizflexFacade {
  private readonly store = inject(Store);

  readonly accessToken$ = this.store.pipe(select(BizflexSelectors.getAccessToken));
  readonly signToken$ = this.store.pipe(select(BizflexSelectors.getSignToken));
  readonly jwt$ = this.store.pipe(select(BizflexSelectors.getJwt));
  readonly applicationId$ = this.store.pipe(select(BizflexSelectors.getApplicationId));
  readonly company$ = this.store.pipe(select(BizflexSelectors.getCompany));
  readonly currencyCode$ = this.store.pipe(select(BizflexSelectors.getCurrencyCode));
  readonly director$ = this.store.pipe(select(BizflexSelectors.getDirector));
  readonly directors$ = this.store.pipe(select(BizflexSelectors.getDirectors));
  readonly loanCalculator$ = this.store.pipe(select(BizflexSelectors.getLoanCalculator));
  readonly leadSubmissionToken$ = this.store.pipe(select(BizflexSelectors.getLeadSubmissionToken));
  readonly leadSubmission$ = this.store.pipe(select(BizflexSelectors.getLeadSubmission));

  reset(initialState: ResetStateProps['initialState'] = {}): void {
    this.store.dispatch(BizflexActions.reset({ initialState }));
  }

  setAccessToken(accessToken: string | null): void {
    this.store.dispatch(BizflexActions.setAccessToken({ accessToken }));
  }

  setSignToken(signToken: string): void {
    this.store.dispatch(BizflexActions.setSignToken({ signToken }));
  }

  setApplicationId(applicationId: string): void {
    this.store.dispatch(BizflexActions.setApplicationId({ applicationId }));
  }

  setCompany(company: CompanyModel): void {
    this.store.dispatch(BizflexActions.setCompany({ company }));
  }

  setCurrencyCode(currencyCode: string): void {
    this.store.dispatch(BizflexActions.setCurrencyCode({ currencyCode }));
  }

  setDirector(director: DirectorModel): void {
    this.store.dispatch(BizflexActions.setDirector({ director }));
  }

  setDirectors(directors: DirectorModel[]): void {
    this.store.dispatch(BizflexActions.setDirectors({ directors }));
  }

  setLoanCalculator(loanCalculator: LoanCalculatorModel): void {
    this.store.dispatch(BizflexActions.setLoanCalculator({ loanCalculator }));
  }

  setLeadSubmissionToken(leadSubmissionToken: string): void {
    this.store.dispatch(BizflexActions.setLeadSubmissionToken({ leadSubmissionToken }));
  }

  setLeadSubmission(leadSubmission: LeadModel): void {
    this.store.dispatch(BizflexActions.setLeadSubmission({ leadSubmission }));
  }
}
